<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full rounded-xl">
                    <div v-if="campaign.fullImageUrl != null" class="campaign-image">
                        <div class="rounded-t-xl" :style="{'background-image': `url('${campaign.fullImageUrl}')`}"></div>
                    </div>
                    <div class="p-4">
                        <div class="text-left text-12 font-medium text-a-black-d0d0ce pt-3" v-html="agency"></div>
                        <div class="text-left text-12 font-light text-a-black-d0d0ce pb-4 border-b border-a-gray-d0d0ce" v-html="title"></div>
                        <div class="text-center text-lg pb-5 pt-3">
                            <BuyConfirmRedeem
                                :campaign="campaign"
                                v-if="type == 'buy'" />
                            <DefaultConfirmRedeem
                                :campaign="campaign"
                                v-if="type == 'default'" />
                            <DeliveryConfirmRedeem
                                :campaign="campaign"
                                v-if="type == 'delivery'" />
                            <DrawConfirmRedeem
                                :campaign="campaign"
                                v-if="type == 'draw'" />
                            <InterfaceConfirmRedeem
                                :campaign="campaign"
                                v-if="type == 'interface'" />
                        </div>
                        <div>
                            <button class="w-full bg-a-orange-fe5000 text-white rounded-full py-3 my-1 leading-6 text-18" @click="clickOk()">
                                {{btnOk}}
                            </button>
                            <button class="w-full text-a-orange-fe5000 border-2 border-a-orange-fe5000 rounded-full py-2.5 my-1 leading-6 text-18" @click="clickCancel()">
                                {{btnCancel}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import { CampaignType } from "@/helper/StaticValue.js";
//component
import BuyConfirmRedeem from './component/BuyConfirmRedeem.vue';
import DefaultConfirmRedeem from './component/DefaultConfirmRedeem.vue';
import DeliveryConfirmRedeem from './component/DeliveryConfirmRedeem.vue';
import DrawConfirmRedeem from './component/DrawConfirmRedeem.vue';
import InterfaceConfirmRedeem from './component/InterfaceConfirmRedeem.vue';
import { useTracking } from "@/feature/TrackingFeature"

export default {
    name: "ConfirmRedeemModal",
    mixins: [LocaleMixin],
    components: {
        BuyConfirmRedeem,
        DefaultConfirmRedeem,
        DeliveryConfirmRedeem,
        DrawConfirmRedeem,
        InterfaceConfirmRedeem,
    },
    props: {
        controller: Object,
    },
    setup: function() {
        /**@type {import('@/helper/TrackingHelper').TrackingService} */
        const tracking = useTracking()

        return {
            tracking,
        }
    },
    data: function() {
        return {
            open: false,

            type: null,
            campaign: null,
            btnOk: '',
            btnCancel: '',
            busModal: null,
            title: '',
            agency: '',
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function() {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function(config) {
            this.campaign = config.campaign;
            this.agency = this.campaign.agencyName
            this.title = this.campaign.name
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.confirm_redeem.confirm;
            }
            if (Util.isEmptyStr(this.btnCancel)) {
                this.btnCancel = this.lbl.confirm_redeem.cancel;
            }

            this.initialModal();
            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.tracking.event("privilege_page_detail", "click_confirm_redeem_privilege", this.campaign.id+"|"+this.campaign.name, "");
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickCancel: function() {
            this.tracking.event("privilege_page_detail", "click_cancel_redeem_privilege", this.campaign.id+"|"+this.campaign.name, "");
            this.hide();
            this.controller.sendCallbackCancel();
        },

        initialModal: function () {
            if (!this.campaign.delivered) {
                switch (this.campaign.type) {
                    case CampaignType.Buy:
                        this.type = 'buy';
                        break;
                    case CampaignType.Draw:
                        this.type = 'draw';
                        break;
                    case CampaignType.Interface:
                        this.type = 'interface';
                        break;
                    case CampaignType.Free:
                    case CampaignType.Deal:
                        this.type = 'default';
                        break;
                }
            } else {
                this.type = 'delivery';
            }
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    @import "@/style/base/image.scss";
    .modal {
        @extend %modal;
    }
    .campaign-image {
        div {
            @include boxRatio(66.66%);
        }
    }
</style>
